<template>
  <div class="content">

    <div class="card-box data-table">
      <div class="inp-list">
        <div class="item">
          <span class="label">{{ $t("g.create_at") }}</span>
          <el-date-picker class="inp" v-model="formData.valTime" value-format="YYYY-MM-DD" size="small" type="daterange"
            unlink-panels :range-separator="$t('g.to')" :start-placeholder="$t('g.start_date')"
            :end-placeholder="$t('g.end_date')" :shortcuts="render.shortcuts">
          </el-date-picker>
        </div>

        <div class="item">
          <span class="label">{{ $t('g.operator') }}</span>
          <el-cascader size="small" style="width: 100%;flex: 1;" :clearable="true" v-model="formData.valCode"
            :props="formData.props" :options="render.cascade_options_direct" />
        </div>
        <div class="item">
          <span class="label">{{ $t('bill.status') }}</span>
          <el-select class="inp" size="small" v-model="formData.valStatus" :placeholder="$t('g.choose')">
            <el-option v-for="item in render.statuses" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="item">
          <span class="label">{{ $t('bill.name') }}</span>
          <el-input class="inp" size="small" v-model="formData.valName"
            :placeholder="$t('bill.user_nickname')"></el-input>
        </div>
      </div>
      <div class="btn-ct">
        <el-button @click="func.search" class="search" type="primary">{{ $t('g.search') }}</el-button>
        <!-- <el-button @click="func.showAddDataDialog" type="primary" class="btn-add">新增</el-button> -->
      </div>
      <div class="line"></div>
      <el-table :data="formData.tableData" :stripe="true" @expand-change="func.expand" style="width: 100%">
        <!-- <el-table-column type="expand">
          <template #default="scope">
            <div class="table-detail">
              <div class="item" v-if="!formData.orders[scope.row.Id]">{{ $t('g.loading') }}</div>
              <div class="orders" v-else>
                <div class="order" v-for="(item, idx) in formData.orders[scope.row.Id]" :key="idx">
                  <div>{{ $t('bill.no') }} : {{ item.OrderSn }}</div>
                  <div>{{ $t('bill.money') }} : {{ item.OrderPrice }}</div>
                  <div>{{ $t('bill.refunded') }} : {{ item.RefundMoney }}</div>
                  <el-button size="small" @click="func.refund(scope.row.Id, item)" class="btn" type="primary" round>{{
                    $t('bill.refund') }}</el-button>
                </div>
              </div>
            </div>
          </template>
</el-table-column> -->
        <el-table-column prop="Id" label="ID" width="80">
        </el-table-column>
        <el-table-column prop="Nickname" :label="$t('bill.nickname')" width="140">
        </el-table-column>
        <el-table-column prop="AgentCode" v-if="!isOperator()" :label="$t('g.agent_code')" width="100">
        </el-table-column>
        <el-table-column prop="Money" width="120" :label="$t('bill.refund_money')">
        </el-table-column>
        <el-table-column prop="RefundMoney" width="120" :label="$t('bill.refunded_money')">
        </el-table-column>
        <el-table-column prop="CheckUserId" width="120" :label="$t('withdrawFunds.operator_ID')">
          <template #default="scope">
            <span>{{ scope.row.CheckUserId != 0 ? scope.row.CheckUserId : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="100" :label="$t('bill.status')">
          <template #default="scope">
            <el-tag
              :class="scope.row.Status == 0 ? 'tag-warning' : (scope.row.Status == 1 ? 'tag-fail' : 'tag-success')">
              {{
                scope.row.Status == 0 ? $t('bill.rs.waiting') : (scope.row.Status == 1 ? $t('bill.rs.refunding') :
                  $t('bill.rs.refunded'))
              }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="CreateAtStr" min-width="180" :label="$t('g.create_at')">
        </el-table-column>
        <el-table-column min-width="90" :label="$t('g.operation')" fixed="right">
          <template #default="scope">
            <el-button @click="func.onRefund(scope.row)" v-if="scope.row.Status == 0 || scope.row.Status == 1"
              class="btn-edit" type="info" style="margin-left: 10px;">{{
                $t('bill.refund')
              }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <span class="title">{{ $t("g.unit_num") }}:{{ formData.total }}，{{ $t("g.per_page") }}:{{ formData.pageSize
        }}</span>
        <el-pagination background layout="prev, pager, next" @current-change="func.pageChange"
          :page-size="formData.pageSize" :current-page="formData.curPage" :total="formData.total">
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="$t('bill.refund')" v-model="formData.dialogVisible" class="new-el-dialog" center align-center
      width="80%">
      <el-table :data="formData.moneyList" :stripe="true">
        <el-table-column prop="OrderSn" :label="$t('bill.no')">
        </el-table-column>
        <el-table-column prop="OrderPrice" :label="$t('bill.money')">
        </el-table-column>
        <el-table-column prop="RefundMoney" :label="$t('bill.refunded')">
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template #default="scope">
            <el-button @click="func.refund(scope.row)" class="btn-delete" type="primary" round>{{
              $t('bill.refund') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { reactive, onMounted, computed } from 'vue'
import { shortcuts, operators, cascade_options_direct } from '@/data/default'
import { toDay } from '@/common/func'
import axios from "axios"
import { ElMessage, ElMessageBox } from 'element-plus'
import cfg from '@/common/conf'
import { user, isOperator } from '@/data/token'
import i18n from '@/data/i18n/index'

export default {
  name: 'BillRefund',
  setup() {
    const t = i18n.global.t
    const tableData = []
    const statuses = [
      {
        label: t('bill.rs.all'),
        value: -1
      },
      {
        label: t('bill.rs.waiting'),
        value: 0
      },
      {
        label: t('bill.rs.refunding'),
        value: 1
      },
      {
        label: t('bill.rs.refunded'),
        value: 2
      },
    ]

    const render = {
      statuses,
      operators,
      shortcuts,
      cascade_options_direct
    }
    const formData = reactive({
      tableData,
      orders: {},
      moneyList: [],
      curData: {},
      valTime: '',
      valStatus: -1,
      curPage: 1,
      pageSize: 10,
      dialogVisible: false,
      total: 0,
      valName: '',
      valCode: 0,
      props: {
        children: "Children", expandTrigger: 'hover',
        label: "Name",
        value: "CodePath",
        emitPath: false,
        checkStrictly: true
      },
    })
    const func = {
      onRefund(item) {
        formData.moneyList = []
        func.getMoneyLog(item)
        formData.curData = item
        formData.dialogVisible = true
      },
      refund(order) {
        ElMessageBox.confirm(
          t('bill.sure_refund'),
          t('tips'),
          {
            confirmButtonText: t('confirm'),
            cancelButtonText: t('cancel'),
            type: 'warning',
          }
        )
          .then(() => {
            return axios.post("/admin/moneyLog/orderRefund", {
              orderSn: order.OrderSn,
              refundApplyId: formData.curData.Id
            })
          })
          .then(() => {
            formData.dialogVisible = false
            return func.loadData()
            // return axios.get("/admin/moneyLog/userChargeOrder?userId="+order.UserId)
          })
          .then((res) => {
            console.log("res", res)
            formData.orders[id] = res
          })
          .catch(() => {

          })
      },
      async getMoneyLog(row) {

        const res = await axios.get("/admin/moneyLog/userChargeOrder?id=" + row.Id)
        formData.moneyList = res

      },
      async expand(row, state) {
        if (state.length) {
          const res = await axios.get("/admin/moneyLog/userChargeOrder?id=" + row.Id)
          formData.orders[row.Id] = res
        }
      },
      search() {
        console.log('formData', formData)
        func.loadData()
      },
      pageChange(val) {
        console.log('page change', val)
        func.loadData(val)
      },
      async loadData(page = 1) {
        try {
          formData.tableData = []
          formData.curPage = page
          let params = {
            page,
            type: 2,
          }
          if (formData.valStatus != -1) {
            params.status = formData.valStatus
          }
          if (formData.valName) {
            params.nickname = formData.valName
          }
          if (formData.valCode) {
            params.agentCode = formData.valCode
          }
          if (formData.valTime) {
            params.startAt = Math.floor(Date.parse(formData.valTime[0] + " 00:00:00") / 1000)
            params.endAt = Math.floor(Date.parse(formData.valTime[1] + " 23:59:59") / 1000)
          }
          let res = await axios.get(`/admin/moneyLog/refundApply`, {
            params
          })
          formData.total = res.Total
          res.List.map((item) => {
            item.CreateAtStr = toDay(item.CreateAt)
          })
          formData.tableData = res.List
          formData.pageSize = res.PageSize
        } catch (e) {
          console.log("loadData", e)
        }
      }
    }
    onMounted(() => {
      func.loadData()
    })
    return {
      func,
      render,
      formData,
      isOperator,
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  box-sizing: border-box;
  padding: 1.25rem;

  .table-detail {
    display: flex;
    flex-direction: column;
    margin-right: 9.375rem;
    padding-left: 4rem;
    padding-top: 1rem;

    .orders {
      .order {
        display: flex;
        margin-bottom: 0.5rem;
        align-items: center;

        >div {
          margin-right: 1rem;
        }
      }
    }

    >.item {
      margin-right: 0.625rem;
      display: flex;
      align-items: center;
      margin-bottom: 0.625rem;
      color: #333333;

      >img {
        margin-left: 0.625rem;
        width: 4rem;
        height: 3rem;
        object-fit: cover;
      }
    }
  }

  .boximg {
    width: 4rem;
    height: 3rem;
    object-fit: cover;
  }

  >.card-box {
    font-size: 0.875rem;
    background-color: #fff;
    box-shadow: $box-shadow;
    box-sizing: border-box;
    padding: 1.25rem;
    border-radius: 0.3rem;
    margin-bottom: 1.25rem;

    .header {
      text-align: left;
      margin-bottom: 1.25rem;
      position: relative;

      >.title {
        font-size: 1rem;
        font-weight: 500;
      }

      >.header-icons {
        position: absolute;
        right: 10px;
        top: 0px;
        z-index: 100;

        .header-icon {
          font-size: 0.875rem;
          font-weight: 500;
          border: 1px solid #ddd;
          color: #969696;
          padding: 0.25rem;
          border-radius: 50%;
          color: pointer;
          margin-left: 0.625rem;
          cursor: pointer;
        }
      }
    }

    >.btn-ct {
      text-align: right;

      :deep(.el-button--small) {
        padding: 0.625rem 2rem;
      }
    }

    .inp-list {
      display: grid;
      margin: 0 auto;
      margin-top: 1rem;
      grid-template-columns: repeat(4, 24.1%);
      gap: 14px 16px;

      >.item {
        display: flex;
        align-items: center;

        .label {
          display: flex;
          justify-content: left;
          min-width: 76px;
        }

        :deep(.el-range-editor--small.el-input__inner) {
          flex: 1;
        }

        .inp {
          flex: 1;
        }
      }
    }
  }

  >.el-alert-my {
    margin-bottom: 1.25rem;
    box-shadow: $box-shadow;
    padding: 1.25rem;

    .el-alert-my-txt {
      font-size: 0.875rem;

      >.tips {
        font-weight: bold;
      }
    }

    :deep(.el-alert__closebtn) {
      top: 1.25rem;
      font-size: 1rem;
    }
  }

  >.data-table {
    :deep(.el-table) {
      .cell {
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .el-table__row {
        cursor: pointer;
      }
    }
  }

  >.pagination {
    text-align: right;
    margin-top: 1.25rem;
  }

  .el-form-row {
    display: flex;
    justify-content: space-between;

    :deep(.el-form-item) {
      width: 49%;
    }

    &.line-3 {
      :deep(.el-form-item) {
        width: 33%;
      }
    }

    .inp {
      width: 100%;
    }

    .avatar-uploader {
      :deep(.el-upload) {
        border: 1px dashed #d9d9d9;
        border-radius: 0.375rem;
        cursor: pointer;
        position: relative;
        overflow: hidden;

        &:hover {
          border-color: #409eff;
        }
      }
    }

    .avatar-uploader-icon {
      font-size: 1.75rem;
      color: #8c939d;
      width: 11rem;
      height: 9rem;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .avatar {
      width: 11rem;
      height: 9rem;
      display: block;
      object-fit: cover;
    }
  }

  .new-el-dialog {
    display: flex;

    .order {
      display: flex;
      justify-content: space-around;
      font-size: 18px;
      margin-bottom: 20px;
    }
  }

  .el-select-my {
    text-align: left;
    display: block;
  }
}
</style>
